import { combineReducers } from 'redux';
import {
  ADD_TEAM_MEMBER_CLICKED,
  CANCEL_NEW_INVITATION,
  NEW_INVITATION_FIRST_NAME_CHANGED,
  NEW_INVITATION_LAST_NAME_CHANGED,
  NEW_INVITATION_EMAIL_CHANGED,
  NEW_INVITATION_ROLE_ID_CHANGED,
  NEW_INVITATION_COMPANY_CHANGED,
  NEW_INVITATION_VENUE_OWNERSHIP_CLICKED,
  NEW_INVITATION_CREATION_SUCCESS,
  NEW_INVITATION_ERRORS_CHANGED,
  NEW_INVITATION_SUBMITTING,
  NEW_INVITATION_ENABLE_ALL_VENUES_CLICK,
  NEW_INVITATION_DISABLE_ALL_VENUES_CLICK,
  EDIT_TEAM_MANAGEABLE_CLICKED,
  EDIT_TEAM_MANAGEABLE_CANCELED,
  TEAM_MANAGEABLE_DELETED,
  TEAM_MANAGEABLE_TO_EDIT_FIRST_NAME_CHANGED,
  TEAM_MANAGEABLE_TO_EDIT_LAST_NAME_CHANGED,
  TEAM_MANAGEABLE_TO_EDIT_EMAIL_CHANGED,
  TEAM_MANAGEABLE_TO_EDIT_ROLE_ID_CHANGED,
  TEAM_MANAGEABLE_TO_EDIT_VENUE_OWNERSHIP_CLICKED,
  TEAM_MANAGEABLE_TO_EDIT_ENABLE_ALL_VENUES_CLICK,
  TEAM_MANAGEABLE_TO_EDIT_DISABLE_ALL_VENUES_CLICK,
  TEAM_MANAGEABLE_TO_EDIT_UPDATED,
  TEAM_MANAGEABLE_TO_EDIT_ERRORS_CHANGED,
  TEAM_MANAGEABLE_TO_EDIT_COMPANY_CHANGED,
  SEARCH_TERM_CHANGED,
  ROLE_FILTER_CHANGED,
  VENUE_FILTER_CHANGED,
  CURRENT_PAGE_CHANGED,
  PAGE_SIZE_CHANGED,
  TOGGLE_MEMBER_SELECTION,
  SELECT_ALL_MEMBERS,
  DESELECT_ALL_MEMBERS,
  CLEAR_FILTERS,
  OPEN_MEMBER_MODAL,
  CLOSE_MEMBER_MODAL,
  SORT_CHANGED,
  TEAM_FUNCTION_CREATED,
  TEAM_FUNCTION_UPDATED,
  TEAM_FUNCTION_DELETED,
  TEAM_FUNCTION_FILTER_CHANGED,
  NEW_INVITATION_TEAM_FUNCTION_IDS_CHANGED,
  TEAM_MANAGEABLE_TO_EDIT_TEAM_FUNCTION_IDS_CHANGED
} from '../constants/teamManagerConstants';

const venueOwnerships = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export const teamMemberships = (state = [], action) => {
  switch (action.type) {
    case TEAM_MANAGEABLE_TO_EDIT_UPDATED:
      return [...state].map((teamMembership) => {
        if(teamMembership.id === action.teamManageable.id && teamMembership.type_for_ui === action.teamManageable.type_for_ui){
          return Object.assign({}, action.teamManageable, {currentlyEditing: false});
        } else {
          return Object.assign({}, teamMembership, {currentlyEditing: false});
        }
      });
    case TEAM_MANAGEABLE_DELETED:
      return [...state].filter((teamMembership) => (
        !(teamMembership.type_for_ui === action.teamManageable.type_for_ui
          && teamMembership.id === action.teamManageable.id)
      ));
    case EDIT_TEAM_MANAGEABLE_CANCELED:
      return [...state].map((teamMembership) => (
        Object.assign({}, teamMembership, {currentlyEditing: false})
      ));
    case TEAM_FUNCTION_DELETED:
      return state.map((member) =>
        member.team_function_ids?.includes(action.teamFunctionId)
          ? {
              ...member,
              team_function_ids: member.team_function_ids.filter((id) => id !== action.teamFunctionId),
              team_functions: (member.team_functions || []).filter((fn) => fn.id !== action.teamFunctionId)
            }
          : member
      );
    case EDIT_TEAM_MANAGEABLE_CLICKED:
      return [...state].map((teamMembership) => {
        var currentlyEditing = (
          teamMembership.type_for_ui === action.teamManageable.type_for_ui
            && teamMembership.id === action.teamManageable.id
        );

        return Object.assign({}, teamMembership, {
          currentlyEditing: currentlyEditing
        });
      });
    default:
      return state;
  }
};

export const pendingInvitations = (state = [], action) => {
  switch (action.type) {
    case TEAM_MANAGEABLE_TO_EDIT_UPDATED:
      return [...state].map((teamMembership) => {
        if(teamMembership.id === action.teamManageable.id && teamMembership.type_for_ui === action.teamManageable.type_for_ui){
          return Object.assign({}, action.teamManageable, {currentlyEditing: false});
        } else {
          return Object.assign({}, teamMembership, {currentlyEditing: false});
        }
      });
    case TEAM_MANAGEABLE_DELETED:
      return [...state].filter((teamMembership) => (
        !(teamMembership.type_for_ui === action.teamManageable.type_for_ui
          && teamMembership.id === action.teamManageable.id)
      ));
    case EDIT_TEAM_MANAGEABLE_CANCELED:
      return [...state].map((teamMembership) => (
        Object.assign({}, teamMembership, {currentlyEditing: false})
      ));
    case NEW_INVITATION_CREATION_SUCCESS:
      return [...state, action.invitation];
    case TEAM_FUNCTION_DELETED:
      return state.map((member) =>
        member.team_function_ids?.includes(action.teamFunctionId)
          ? {
              ...member,
              team_function_ids: member.team_function_ids.filter((id) => id !== action.teamFunctionId),
              team_functions: (member.team_functions || []).filter((fn) => fn.id !== action.teamFunctionId)
            }
          : member
      );
    case EDIT_TEAM_MANAGEABLE_CLICKED:
      return [...state].map((teamMembership) => {
        var currentlyEditing = (
          teamMembership.type_for_ui === action.teamManageable.type_for_ui
            && teamMembership.id === action.teamManageable.id
        );

        return Object.assign({}, teamMembership, {
          currentlyEditing: currentlyEditing
        });
      });
    default:
      return state;
  }
};

const addingNewInvitation = (state = false, action) => {
  switch (action.type) {
    case NEW_INVITATION_CREATION_SUCCESS:
      return false;
    case ADD_TEAM_MEMBER_CLICKED:
      return true;
    case CANCEL_NEW_INVITATION:
    case EDIT_TEAM_MANAGEABLE_CLICKED:
      return false;
    default:
      return state;
  }
};

const newInvitation = (state = {}, action) => {
  switch (action.type) {
    case NEW_INVITATION_CREATION_SUCCESS:
      return {};
    case NEW_INVITATION_FIRST_NAME_CHANGED:
      return Object.assign({}, state, {firstName: action.firstName});
    case NEW_INVITATION_LAST_NAME_CHANGED:
      return Object.assign({}, state, {lastName: action.lastName});
    case NEW_INVITATION_EMAIL_CHANGED:
      return Object.assign({}, state, {email: action.email});
    case NEW_INVITATION_COMPANY_CHANGED:
      return Object.assign({}, state, {company: action.company});
    case NEW_INVITATION_ROLE_ID_CHANGED:
      return Object.assign({}, state, {roleId: action.roleId});
    case NEW_INVITATION_ERRORS_CHANGED:
      return Object.assign({}, state, {errors: action.errors});
    case NEW_INVITATION_VENUE_OWNERSHIP_CLICKED:
      var venueOwnershipIds = (state.venueOwnershipIds ? [...state.venueOwnershipIds] : []);

      if (venueOwnershipIds.includes(action.venueOwnershipId)){
        venueOwnershipIds = venueOwnershipIds.filter((id) => {
          return id !== action.venueOwnershipId
        });
      } else {
        venueOwnershipIds = venueOwnershipIds.concat(action.venueOwnershipId);
      }

      return Object.assign({}, state, {venueOwnershipIds: venueOwnershipIds});
    case NEW_INVITATION_ENABLE_ALL_VENUES_CLICK:
      var venueOwnershipIds = action.venueOwnerships.map((venueOwnership) => {
        return venueOwnership.id;
      });

      return Object.assign({}, state, {venueOwnershipIds: venueOwnershipIds});
    case NEW_INVITATION_DISABLE_ALL_VENUES_CLICK:
      return Object.assign({}, state, {venueOwnershipIds: []});
    case NEW_INVITATION_TEAM_FUNCTION_IDS_CHANGED:
      return Object.assign({}, state, {teamFunctionIds: action.teamFunctionIds});
    default:
      return state;
  }
};

const roles = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const csrfToken = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const team = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const newInvitationEnableAllVenues = (state = true, action) => {
  switch (action.type) {
    case NEW_INVITATION_CREATION_SUCCESS:
      return true;
    case NEW_INVITATION_ENABLE_ALL_VENUES_CLICK:
      return false;
    case NEW_INVITATION_DISABLE_ALL_VENUES_CLICK:
      return true;
    default:
      return state;
  }
};

const newInvitationSubmitting = (state = false, action) => {
  switch (action.type) {
    case NEW_INVITATION_SUBMITTING:
      return action.submitting;
    case NEW_INVITATION_CREATION_SUCCESS:
    case NEW_INVITATION_ERRORS_CHANGED:
      return false;
    default:
      return state;
  }
};

const teamManageableToEdit = (state = {}, action) => {
  switch (action.type) {
    case TEAM_MANAGEABLE_TO_EDIT_UPDATED:
    case EDIT_TEAM_MANAGEABLE_CANCELED:
      return {};
    case EDIT_TEAM_MANAGEABLE_CLICKED:
      return action.teamManageable;
    case TEAM_MANAGEABLE_TO_EDIT_FIRST_NAME_CHANGED:
      return Object.assign({}, state, {first_name: action.firstName});
    case TEAM_MANAGEABLE_TO_EDIT_LAST_NAME_CHANGED:
      return Object.assign({}, state, {last_name: action.lastName});
    case TEAM_MANAGEABLE_TO_EDIT_EMAIL_CHANGED:
      return Object.assign({}, state, {email: action.email});
    case TEAM_MANAGEABLE_TO_EDIT_COMPANY_CHANGED:
      return Object.assign({}, state, {company: action.company});
    case TEAM_MANAGEABLE_TO_EDIT_ROLE_ID_CHANGED:
      return Object.assign({}, state, {role_id: action.roleId});
    case TEAM_MANAGEABLE_TO_EDIT_ERRORS_CHANGED:
      return Object.assign({}, state, {errors: action.errors});
    case TEAM_MANAGEABLE_TO_EDIT_VENUE_OWNERSHIP_CLICKED:
      var venueOwnershipIds = (state.venue_ownership_ids ? [...state.venue_ownership_ids] : []);

      if (venueOwnershipIds.includes(action.venueOwnershipId)){
        venueOwnershipIds = venueOwnershipIds.filter((id) => {
          return id !== action.venueOwnershipId
        });
      } else {
        venueOwnershipIds = venueOwnershipIds.concat(action.venueOwnershipId);
      }

      return Object.assign({}, state, {venue_ownership_ids: venueOwnershipIds});
    case TEAM_MANAGEABLE_TO_EDIT_ENABLE_ALL_VENUES_CLICK:
      var venueOwnershipIds = action.venueOwnerships.map((venueOwnership) => {
        return venueOwnership.id;
      });

      return Object.assign({}, state, {venue_ownership_ids: venueOwnershipIds});
    case TEAM_MANAGEABLE_TO_EDIT_DISABLE_ALL_VENUES_CLICK:
      return Object.assign({}, state, {venue_ownership_ids: []});
    case TEAM_MANAGEABLE_TO_EDIT_TEAM_FUNCTION_IDS_CHANGED:
      return Object.assign({}, state, {team_function_ids: action.teamFunctionIds});
    default:
      return state;
  }
};

const teamManageableToEditEnableAllVenues = (state = true, action) => {
  switch (action.type) {
    case EDIT_TEAM_MANAGEABLE_CLICKED:
      const memberVenueIds = action.teamManageable.venue_ownership_ids || [];
      const allVenueIds = (action.venueOwnerships || []).map(v => v.id);
      const allSelected = allVenueIds.length > 0 &&
        allVenueIds.every(id => memberVenueIds.includes(id));
      return !allSelected;
    case TEAM_MANAGEABLE_TO_EDIT_ENABLE_ALL_VENUES_CLICK:
      return false;
    case TEAM_MANAGEABLE_TO_EDIT_DISABLE_ALL_VENUES_CLICK:
      return true;
    default:
      return state;
  }
};

// Search, Filter, Pagination Reducers
const searchTerm = (state = '', action) => {
  switch (action.type) {
    case SEARCH_TERM_CHANGED:
      return action.searchTerm;
    case CLEAR_FILTERS:
      return '';
    default:
      return state;
  }
};

const roleFilter = (state = [], action) => {
  switch (action.type) {
    case ROLE_FILTER_CHANGED:
      return action.roleFilter || [];
    case CLEAR_FILTERS:
      return [];
    default:
      return state;
  }
};

const venueFilter = (state = [], action) => {
  switch (action.type) {
    case VENUE_FILTER_CHANGED:
      return action.venueFilter || [];
    case CLEAR_FILTERS:
      return [];
    default:
      return state;
  }
};

const currentPage = (state = 1, action) => {
  switch (action.type) {
    case CURRENT_PAGE_CHANGED:
      return action.currentPage;
    case SEARCH_TERM_CHANGED:
    case ROLE_FILTER_CHANGED:
    case VENUE_FILTER_CHANGED:
    case CLEAR_FILTERS:
      return 1; // Reset to page 1 when filters change
    default:
      return state;
  }
};

const pageSize = (state = 10, action) => {
  switch (action.type) {
    case PAGE_SIZE_CHANGED:
      return action.pageSize;
    default:
      return state;
  }
};

const sortBy = (state = 'name', action) => {
  switch (action.type) {
    case SORT_CHANGED:
      return action.sortBy;
    default:
      return state;
  }
};

const sortDirection = (state = 'asc', action) => {
  switch (action.type) {
    case SORT_CHANGED:
      return action.sortDirection;
    default:
      return state;
  }
};

const selectedMemberIds = (state = [], action) => {
  switch (action.type) {
    case TOGGLE_MEMBER_SELECTION:
      if (state.includes(action.memberId)) {
        return state.filter(id => id !== action.memberId);
      }
      return [...state, action.memberId];
    case SELECT_ALL_MEMBERS:
      return action.memberIds;
    case DESELECT_ALL_MEMBERS:
    case SEARCH_TERM_CHANGED:
    case ROLE_FILTER_CHANGED:
    case VENUE_FILTER_CHANGED:
    case CLEAR_FILTERS:
    case CURRENT_PAGE_CHANGED:
      // When filters or page change, clear selection so bulk delete cannot
      // operate on hidden or stale rows.
      return [];
    default:
      return state;
  }
};

const memberModalOpen = (state = false, action) => {
  switch (action.type) {
    case OPEN_MEMBER_MODAL:
      return true;
    case CLOSE_MEMBER_MODAL:
    case NEW_INVITATION_CREATION_SUCCESS:
    case TEAM_MANAGEABLE_TO_EDIT_UPDATED:
      return false;
    default:
      return state;
  }
};

const memberModalMode = (state = 'add', action) => {
  switch (action.type) {
    case OPEN_MEMBER_MODAL:
      return action.mode || 'add';
    case CLOSE_MEMBER_MODAL:
      return 'add';
    default:
      return state;
  }
};

export const teamFunctions = (state = [], action) => {
  const byName = (a, b) => a.name.localeCompare(b.name);
  switch (action.type) {
    case TEAM_FUNCTION_CREATED:
      return [...state, action.teamFunction].sort(byName);
    case TEAM_FUNCTION_UPDATED:
      return state
        .map((f) => (f.id === action.teamFunction.id ? action.teamFunction : f))
        .sort(byName);
    case TEAM_FUNCTION_DELETED:
      return state.filter((f) => f.id !== action.teamFunctionId);
    default:
      return state;
  }
};

export const teamFunctionFilter = (state = [], action) => {
  switch (action.type) {
    case TEAM_FUNCTION_FILTER_CHANGED:
      return action.teamFunctionFilter || [];
    case CLEAR_FILTERS:
      return [];
    default:
      return state;
  }
};

const teamManagerReducer = combineReducers({
  venueOwnerships,
  teamMemberships,
  pendingInvitations,
  teamFunctions,
  addingNewInvitation,
  newInvitation,
  roles,
  csrfToken,
  team,
  newInvitationEnableAllVenues,
  newInvitationSubmitting,
  teamManageableToEdit,
  teamManageableToEditEnableAllVenues,
  searchTerm,
  roleFilter,
  venueFilter,
  teamFunctionFilter,
  currentPage,
  pageSize,
  sortBy,
  sortDirection,
  selectedMemberIds,
  memberModalOpen,
  memberModalMode
});

export default teamManagerReducer;
